import React, { ReactElement } from 'react'

interface DiamondWrapperInterface {
  children: React.ReactElement
  className: string
};

const DiamondWrapper = ({ className, children }: DiamondWrapperInterface): ReactElement => (
  <div className='glow-effect'>
    <div className='relative diamond-corner min-h-[300px] min-w-[670px] p-[4px] bg-dopage-lightGreen shadow-[0px_0px_20px_-4px_rgba(52,232,158,1)]}'>
      <div className={`inner bg-black w-full h-full ${className || ''}`}>
        {children}
      </div>
    </div>
  </div>
)

export default DiamondWrapper
